/** @module components/story-feed */
import baustein from "baustein";
import ScrollToTopButton from "./scroll-to-top-button";

/**
 * @constructor
 * @alias module:components/story-feed
 * @extends module:baustein
 */
export default baustein.register(
    "story-feed",
    /** @lends module:components/story-feed.prototype */
    {
        init: function() {
            var scrollToTopButton = new ScrollToTopButton();
            scrollToTopButton.appendTo(this);
        },
    }
);
